import React, { useEffect, useState } from 'react'
import ContactForm from '../components/ContactForm'

const TussenPersonen = (props) => {
  console.log('TussenPersonen', props)

  // const [filterInterestsActive, setFilterInterestsActive] = useState(false);
  // console.log('TussenPersonen', props);

  const paginationAmount = 5

  const [tussenPersonen, setTussenPersonen] = useState([])
  const [filter, setFilter] = useState('')
  const [activeContactForm, setActiveContactForm] = useState(null)
  const [resultLimit, setResultLimit] = useState(paginationAmount)
  const [isLoading, setIsloading] = useState(true)
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [intermediary, setIntermediary] = useState({})
  const [pageEndNumber, setPageEndNumber] = useState(5)

  useEffect(() => {
    const token = process.env.REACT_APP_SAM_TOKEN
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    }
    fetch(`${process.env.REACT_APP_SAM_URL}/intermediaries-list`, config)
      .then((response) => response.json())
      .then((data) => {
        data.sort((a, b) => a.code - b.code)
        setTussenPersonen(data)
        setIsloading(false)
      })
  }, [])

  const clickContactForm = (index) => {
    setActiveContactForm((prev) => {
      return prev === index ? null : index
    })
  }

  const submittedContactForm = (intermediary) => {
    setIntermediary(intermediary)
    setFormSubmitted(true)

    setActiveContactForm(false)
  }

  let numOfResults = 0
  const filterResults = (filter, list, pageNumber) => {
    numOfResults = list.length

    if (!filter) {
      return list.slice(pageEndNumber - 5, pageEndNumber)
    }

    if (parseInt(filter) && parseInt(filter) >= 1000) {
      const pagList = list
        .filter(
          (item) => (item.code <= parseInt(filter) + 100 && item.code >= parseInt(filter) - 100) || item.landelijk,
        )
        .sort((a, b) => Math.abs(parseInt(a.code) - parseInt(filter)) - Math.abs(parseInt(b.code) - parseInt(filter)))

      numOfResults = pagList.length
      return pagList.slice(pageEndNumber - 5, pageEndNumber)
    }

    if (parseInt(filter)) {
      return list.slice(pageEndNumber - 5, pageEndNumber)
    }

    if (filter.length > 2) {
      const searchStr = filter.toLowerCase()
      const filteredData = list.filter((value) => {
        const nameMatches = value.name.toLowerCase().includes(searchStr)
        const cityMatches = value.city.toLowerCase().includes(searchStr)
        return nameMatches || cityMatches
      })

      numOfResults = filteredData.length
      return filteredData.slice(pageEndNumber - 5, pageEndNumber)
    }

    return list.slice(pageEndNumber - 5, pageEndNumber)
  }

  const paginationLimit = 5

  let currentPage = 1

  const setPagination = (resultLength, next) => {
    let limit
    currentPage = currentPage + paginationLimit
    if (resultLimit + paginationAmount > resultLength) {
      limit = resultLength
    } else {
      limit = resultLimit + paginationAmount
    }
    console.log('setPagination: resultLength', resultLength, limit, 'next', next)
    setResultLimit(limit)
    let pNumber = pageEndNumber
    if (next) {
      pNumber = pNumber + 5
    } else {
      pNumber = pNumber - 5
    }
    setPageEndNumber(pNumber)
  }

  const goBack = () => {
    setFormSubmitted(false)
    props.goBack()
  }

  return (
    <>
      {!formSubmitted && (
        <div>
          <div className="md:flex mb-4 md:mb-0">
            {!activeContactForm && activeContactForm !== 0 ? (
              <h3 className="text-3xl font-bold mb-2 flex-auto">Vind hier uw tussenpersoon</h3>
            ) : (
              <h3 className="text-3xl font-bold mb-6 flex-auto">Neem contact op</h3>
            )}

            {!activeContactForm && activeContactForm !== 0 ? (
              <div className="flex-none">
                <button
                  type="button"
                  onClick={() => props.goBack()}
                  className=" py-1 px-4 border border-white font-medium  hover:bg-primary-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500"
                >
                  Terug naar rentes
                </button>
              </div>
            ) : (
              <div className="flex-none">
                <button
                  type="button"
                  onClick={() => clickContactForm(null)}
                  className=" py-1 px-4 border border-white font-medium  hover:bg-primary-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500"
                >
                  Terug naar tussenpersonen
                </button>
              </div>
            )}
          </div>

          {!isLoading && (
            <div>
              {!activeContactForm && activeContactForm !== 0 && (
                <div className="mb-6 mt-4">
                  <label
                    htmlFor="filterInput"
                    className="block"
                  >
                    Filter op postcode, plaatsnaam of naam
                  </label>
                  <div className="mt-1 flex">
                    <input
                      id="filterInput"
                      name="filterInput"
                      autoComplete="filterInput"
                      value={filter}
                      onChange={(event) => (
                        setFilter(event.target.value), setResultLimit(paginationAmount), setPageEndNumber(5)
                      )}
                      placeholder="Type hier de 4 cijfers van uw postcode of zoek op plaatsnaam"
                      style={{ width: '100%', maxWidth: 640 }}
                      className="input-border-color h-12 mt-0 block px-3 border-0 border-b-4 border-primary-80 text-lg text-secondary-100 focus:border-primary-100 focus:ring-primary-100 focus-visible:ring-primary-100"
                      required
                    />
                  </div>
                </div>
              )}
              {/* {filterResults(filter, tussenPersonen).length} - {resultLimit} - {(pageEndNumber > numOfResults) ? numOfResults : pageEndNumber} */}
              {filterResults(filter, tussenPersonen).map((company, i) =>
                i < filterResults(filter, tussenPersonen).length ? (
                  <div key={i}>
                    {!activeContactForm && activeContactForm !== 0 && (
                      <div className="mb-3 px-4 py-3 bg-white text-secondary-100 rounded-md">
                        <div className="flex items-center">
                          <div className="flex-auto">
                            <h3 className="text-l font-bold">{company.name}</h3>
                            <div>{company.street}</div>
                            <div>
                              {company.zip} {company.city} {company.landelijk && '(Landelijk)'}
                            </div>
                          </div>
                          {activeContactForm !== i && (
                            <button
                              type="button"
                              onClick={() => {
                                clickContactForm(i)
                              }}
                              className=" py-1 px-4 border border-secondary-100 font-medium  hover:bg-secondary-70 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500"
                            >
                              Neem contact op
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                    {activeContactForm === i && (
                      <div className="mb-3 px-4 py-3 bg-white text-secondary-100 rounded-md">
                        <div className="flex items-center">
                          <div className="flex-auto">
                            <h3 className="text-l font-bold">{company.name}</h3>
                            <div>{company.street}</div>
                            <div>
                              {company.zip} {company.city} {company.landelijk && '(Landelijk)'}
                            </div>
                          </div>
                        </div>
                        <ContactForm
                          intermediary={company}
                          selectedRate={props.selectedRate}
                          submitted={(e) => submittedContactForm(e)}
                          cancel={() => clickContactForm(null)}
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  ''
                ),
              )}
              {0 === filterResults(filter, tussenPersonen).length && 'Er zijn geen resultaten gevonden'}

              {!activeContactForm && activeContactForm !== 0 && (
                <div>
                  <div className="text-center mt-8">
                    {numOfResults > 5 && (
                      <div>
                        <button
                          disabled={pageEndNumber <= 5}
                          onClick={() => setPagination(filterResults(filter, tussenPersonen).length, false)}
                          className=" py-2 px-12 mr-2 border border-white font-medium  hover:bg-primary-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500 disabled:opacity-50"
                        >
                          Vorige
                        </button>
                        <button
                          disabled={pageEndNumber >= numOfResults}
                          onClick={() => setPagination(filterResults(filter, tussenPersonen).length, true)}
                          className=" py-2 px-12 ml-2 border border-white font-medium  hover:bg-primary-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500 disabled:opacity-50"
                        >
                          Volgende
                        </button>
                      </div>
                    )}

                    {numOfResults > 5 && (
                      <div className="my-4 text-base">
                        {pageEndNumber - 5} - {pageEndNumber > numOfResults ? numOfResults : pageEndNumber} van{' '}
                        {numOfResults} resultaten
                      </div>
                    )}
                    {numOfResults <= 5 && (
                      <div className="my-4 text-base">
                        {numOfResults} {1 === numOfResults ? 'resultaat' : 'resultaten'}{' '}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {formSubmitted && (
        <div>
          <div className="flex">
            <h3 className="text-3xl font-bold mb-2 flex-auto">Aanvraag is verzonden!</h3>
            <div className="flex-none">
              {/* <button type="button"
                            onClick={() => props.goBack()}
                            className=" py-1 px-4 border border-white font-medium  hover:bg-primary-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500">
                            Terug naar rentes
                        </button> */}
            </div>
          </div>
          <p>
            Uw aanvraag is verzonden naar <b>{intermediary.name}</b>. Zij nemen z.s.m. contact met u op.
          </p>
          <button
            type="button"
            onClick={() => goBack()}
            className="mt-4 py-1 px-4 border border-white font-medium  hover:bg-primary-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500"
          >
            Terug naar rentes
          </button>
        </div>
      )}
    </>
  )
}

export default TussenPersonen
